import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
})

export const createQueryKey = (resource) => {
  const queryKey = {
    all: [resource],
    lists: () => [...queryKey.all, 'list'],
    list: ({ page, pageSize, sortBy, orderBy, filters }) => [
      ...queryKey.lists(),
      { page, pageSize, sortBy, orderBy, filters },
    ],
    details: () => [...queryKey.all, 'detail'],
    detail: (id) => [...queryKey.details(), id],
  }
  return queryKey
}
